import type { TranslateDictionary } from './en.js';

export const Th: TranslateDictionary = {
  'Start airplay': 'เริ่ม AirPlay',
  'Stop airplay': 'หยุด AirPlay',
  Audio: 'เสียง',
  Captions: 'คำบรรยาย',
  'Enable captions': 'เปิดใช้งานคำบรรยาย',
  'Disable captions': 'ปิดใช้งานคำบรรยาย',
  'Start casting': 'เริ่มการส่งสัญญาณ',
  'Stop casting': 'หยุดการส่งสัญญาณ',
  'Casting to {device}': 'กำลังแคสต์ไปที่ {device}',
  'Enter fullscreen mode': 'เข้าสู่โหมดเต็มหน้าจอ',
  'Exit fullscreen mode': 'ออกจากโหมดเต็มหน้าจอ',
  Mute: 'ปิดเสียง',
  Unmute: 'เปิดเสียง',
  'Enter picture in picture mode': 'เข้าสู่โหมดภาพในภาพ',
  'Exit picture in picture mode': 'ออกจากโหมดภาพในภาพ',
  Play: 'เล่น',
  Pause: 'หยุดชั่วคราว',
  'Playback rate': 'ความเร็วการเล่น',
  'Playback rate {playbackRate}': 'ความเร็วการเล่น {playbackRate}',
  Quality: 'คุณภาพ',
  'Seek backward': 'ย้อนกลับ',
  'Seek forward': 'ไปข้างหน้า',
  Settings: 'การตั้งค่า',
  Auto: 'อัตโนมัติ',
  'audio player': 'เครื่องเล่นเสียง',
  'video player': 'เครื่องเล่นวิดีโอ',
  volume: 'ความดังเสียง',
  seek: 'ค้นหา',
  'closed captions': 'คำบรรยาย',
  'current playback rate': 'ความเร็วการเล่นปัจจุบัน',
  'playback time': 'เวลาการเล่น',
  'media loading': 'กำลังโหลดสื่อ',
  settings: 'การตั้งค่า',
  'audio tracks': 'แทร็กเสียง',
  quality: 'คุณภาพ',
  play: 'เล่น',
  pause: 'หยุดชั่วคราว',
  mute: 'ปิดเสียง',
  unmute: 'เปิดเสียง',
  'chapter: {chapterName}': 'บท: {chapterName}',
  live: 'สด',
  Off: 'ปิด',
  'start airplay': 'เริ่ม AirPlay',
  'stop airplay': 'หยุด AirPlay',
  'start casting': 'เริ่มการส่งสัญญาณ',
  'stop casting': 'หยุดการส่งสัญญาณ',
  'enter fullscreen mode': 'เข้าสู่โหมดเต็มหน้าจอ',
  'exit fullscreen mode': 'ออกจากโหมดเต็มหน้าจอ',
  'enter picture in picture mode': 'เข้าสู่โหมดภาพในภาพ',
  'exit picture in picture mode': 'ออกจากโหมดภาพในภาพ',
  'seek to live': 'ไปยังการถ่ายทอดสด',
  'playing live': 'กำลังเล่นสด',
  'seek back {seekOffset} seconds': 'ย้อนกลับ {seekOffset} วินาที',
  'seek forward {seekOffset} seconds': 'ไปข้างหน้า {seekOffset} วินาที',
  'Network Error': 'ข้อผิดพลาดเครือข่าย',
  'Decode Error': 'ข้อผิดพลาดในการถอดรหัส',
  'Source Not Supported': 'ไม่รองรับแหล่งที่มา',
  'Encryption Error': 'ข้อผิดพลาดการเข้ารหัส',
  'A network error caused the media download to fail.':
    'ข้อผิดพลาดเครือข่ายทำให้การดาวน์โหลดสื่อล้มเหลว',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'ข้อผิดพลาดสื่อทำให้การเล่นถูกยกเลิก สื่ออาจเสียหายหรือเบราว์เซอร์ของคุณไม่รองรับรูปแบบนี้',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'เกิดข้อผิดพลาดที่ไม่รองรับ เซิร์ฟเวอร์หรือเครือข่ายล้มเหลว หรือเบราว์เซอร์ของคุณไม่รองรับรูปแบบนี้',
  'The media is encrypted and there are no keys to decrypt it.':
    'สื่อถูกเข้ารหัสและไม่มีคีย์สำหรับถอดรหัส',
  'This video is not available.': 'วิดีโอนี้ไม่พร้อมใช้งาน',
  'This video could not be found.': 'ไม่พบวิดีโอนี้',
};
